import { createBrowserRouter, Navigate, RouteObject } from "react-router-dom";
import LoginPage from "../../features/authentication/login/LoginPage";
import RegisterPage from "../../features/authentication/register/RegisterPage";
import NotFound from "../../features/errors/NotFound";
import App from "../layout/App";
import RequireAuth from "./RequireAuth";
import IndexPage from "../../features/dashboard/analytics";
import OrdersIndex from "../../features/dashboard/orders/OrdersIndex";
import ProductsIndex from "../../features/dashboard/products/ProductsIndex";
import NewProduct from "../../features/dashboard/products/new/NewProduct";
import UsersIndex from "../../features/dashboard/users/UsersIndex";
import NewUser from "../../features/dashboard/users/new/NewUser";
import ViewUser from "../../features/dashboard/users/view/ViewUser";
import TicketsIndex from "../../features/dashboard/tickets/TicketsIndex";
import NewTicket from "../../features/dashboard/tickets/new/NewTicket";
import ShippingIndex from "../../features/dashboard/shipping/ShippingIndex";
import SettingsIndex from "../../features/dashboard/settings/SettingsIndex";
import IndexHomePage from "../../features/home/IndexHomePage";
import CallbackPage from "../../features/home/CallbackPage";
import ChangePasswordStepPage from "../../features/authentication/others/password/ChangePasswordStepPage";
import ConfirmEmailPage from "../../features/authentication/others/email/ConfirmEmailPage";
import UpdateProduct from "../../features/dashboard/products/update/UpdateProduct";
import AllReturnLocations from "../../features/dashboard/shipping/returnlocation/list/AllReturnLocations";
import NewReturnLocation from "../../features/dashboard/shipping/returnlocation/new/NewReturnLocation";
import ShippingLocationPriceIndex from "../../features/dashboard/shipping/shippinglocation/ShippingLocationPriceIndex";
import TermsAndConditions from "../../features/dashboard/terms/TermsAndConditions";
import UpdateReturnLocation from "../../features/dashboard/shipping/returnlocation/edit/UpdateReturnLocation";
import IndexVendorsPage from "../../features/home/IndexVendorsPage";
import IndexVendorPage from "../../features/home/IndexVendorPage";
import ProductDetails from "../../features/dashboard/products/details/ProductDetails";

export const routes: RouteObject[] = [
  {
    path: "/",
    element: <App />,
    children: [
      {
        element: <RequireAuth />,
        children: [
          { path: "vendor/dashboard", element: <IndexPage /> },
          { path: "vendor/orders", element: <OrdersIndex /> },
          { path: "vendor/products", element: <ProductsIndex /> },
          { path: "vendor/products/new-product", element: <NewProduct /> },
          { path: "vendor/products/:id", element: <UpdateProduct /> },
          { path: "vendor/products/details/:id", element: <ProductDetails />},
          { path: "vendor/users", element: <UsersIndex /> },
          { path: "vendor/users/new-user", element: <NewUser /> },
          { path: "vendor/users/:id", element: <ViewUser /> },
          { path: "vendor/tickets", element: <TicketsIndex /> },
          { path: "vendor/tickets/new-ticket", element: <NewTicket /> },
          { path: "vendor/shipping", element: <ShippingIndex /> },
          {
            path: "vendor/shipping/returnlocationlist",
            element: <AllReturnLocations />,
          },
          {
            path: "vendor/shipping/new-returnlocation",
            element: <NewReturnLocation />,
          },
          {
            path: "vendor/shipping/returnlocationlist/:id",
            element: <UpdateReturnLocation />,
          },
          {
            path: "vendor/shipping/shippinglocationprice",
            element: <ShippingLocationPriceIndex />,
          },
          { path: "vendor/settings", element: <SettingsIndex /> },
          { path: "vendor/terms", element: <TermsAndConditions /> },
        ],
      },
      { path: "login", element: <LoginPage /> },
      { path: "verifyemail", element: <ConfirmEmailPage /> },
      { path: "vendors", element: <IndexVendorsPage /> },
      { path: "vendors/:id", element: <IndexVendorPage /> },
      { path: "register", element: <RegisterPage /> },
      { path: "change-password", element: <ChangePasswordStepPage /> },
      { path: "not-found", element: <NotFound /> },
      { path: "", element: <IndexHomePage /> },
      { path: "callback", element: <CallbackPage /> },
      { path: "*", element: <Navigate replace to="/not-found" /> },
    ],
  },
];

export const router = createBrowserRouter(routes);
